import { BasketState, BasketItem, BasketUidPayload } from '@/contracts/store/BasketContracts'

export const Basket =
{
    namespaced: true,
    state: (): BasketState => (
    {
        items: [] as Array<BasketItem>
    }),
    getters:
    {
        getBasket(state: BasketState): Array<BasketItem>
        {
            return state.items
        },
        getBasketCount(state: BasketState): number
        {
            return state.items.length
        }
    },
    mutations:
    {
        addToBasket(state: BasketState, item: BasketItem): void
        {
            state.items.push(item)
        },
        removeFromBasket(state: BasketState, index: number): void
        {
            state.items.splice(index, 1)
        },
        resetBasket(state: BasketState): void
        {
            state.items = []
        },
        transformCalItem(state: BasketState, payload: BasketUidPayload): void
        {
            state.items[payload.index].uid = payload.uid
            state.items[payload.index]['hmctsgrant:price'] = payload.price
        }
    }
}
